var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolume2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 22.333C23.7865 22.333 23.5865 22.2664 23.3999 22.133C22.9599 21.7997 22.8665 21.173 23.1999 20.733C25.2932 17.9464 25.2932 14.053 23.1999 11.2664C22.8665 10.8264 22.9599 10.1997 23.3999 9.86638C23.8399 9.53305 24.4665 9.62638 24.7999 10.0664C27.4132 13.5597 27.4132 18.4397 24.7999 21.933C24.5999 22.1997 24.3065 22.333 23.9999 22.333Z",
    fill: "#096DD9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4398 25.6667C26.2265 25.6667 26.0265 25.6 25.8398 25.4667C25.3998 25.1334 25.3065 24.5067 25.6398 24.0667C29.1998 19.32 29.1998 12.68 25.6398 7.93337C25.3065 7.49337 25.3998 6.8667 25.8398 6.53337C26.2798 6.20004 26.9065 6.29337 27.2398 6.73337C31.3332 12.1867 31.3332 19.8134 27.2398 25.2667C27.0532 25.5334 26.7465 25.6667 26.4398 25.6667Z",
    fill: "#096DD9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.0002 9.88028V22.1203C21.0002 24.4136 20.1735 26.1336 18.6935 26.9603C18.0935 27.2936 17.4268 27.4536 16.7335 27.4536C15.6668 27.4536 14.5202 27.0936 13.3468 26.3603L9.4535 23.9203C9.18683 23.7603 8.88016 23.6669 8.5735 23.6669H7.3335V8.33362H8.5735C8.88016 8.33362 9.18683 8.24028 9.4535 8.08028L13.3468 5.64028C15.2935 4.42695 17.2002 4.21362 18.6935 5.04028C20.1735 5.86695 21.0002 7.58695 21.0002 9.88028Z",
    fill: "#096DD9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33317 8.33301V23.6663H6.6665C3.43984 23.6663 1.6665 21.893 1.6665 18.6663V13.333C1.6665 10.1063 3.43984 8.33301 6.6665 8.33301H7.33317Z",
    fill: "#096DD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume2);
export default __webpack_public_path__ + "static/media/volume_2.a94fc982bc1de65edb7d37bb91ae1146.svg";
export { ForwardRef as ReactComponent };